// src/assets/images/index.js
import heroImage from './nature.png';
// import room1Image from './room.jpg';
import pool from './pool.png';
import pool1 from './pool1.png'
import path from './path.png'
import swing from './swing.png'
import fire from './fire.png'
import main from './main.png'
import badminton from './badminton.png'
import nightsit from './nightsit.png'
import sports from './sports.png'
import party from './party.png'
import camp from './camp.png'
import kids from './kids.png'
import ebin from './ebin.png'
import jimmy from './jimmy.png'
import robin from './robin.png'


// import restaurant from './restaurant.jpg';

export const images = {
  hero: heroImage,
  pool1,
  fire,
  swing,
  robin,
  path,
  jimmy,
  ebin,
  kids,
  camp,
  party,
  sports,
  pool,
  badminton,
  nightsit,
  main,
};

export default images;

// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAD7LBhe3A1gG4kmSOvtjulCfTXkj4qd2s",
//   authDomain: "eastfort-ad642.firebaseapp.com",
//   projectId: "eastfort-ad642",
//   storageBucket: "eastfort-ad642.firebasestorage.app",
//   messagingSenderId: "24105392206",
//   appId: "1:24105392206:web:70bf912975965cd971cb1f",
//   measurementId: "G-M27SPSD157"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);